import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// api
import { changeRecoverPassword } from "api/users";
//slices
import { companySelector } from 'slices/company';
// helpers
import { unSetLocal } from "helpers";
// components
import { InputCustom } from "components/input";
import Button from "components/userzone/buttons/ButtonCustom";
// styles
import "./recover.scss";

const Recover = () => {
  const { name } = useSelector(companySelector);
  const { t } = useTranslation(['recover', 'backoffice'])
  const [disableBtnRecoverPass, setDisableBtnRecoverPass] = useState(false);
  const [errorRecoverPass, setErrorRecoverPass] = useState("");
  const [successRecoverPass, setSuccessRecoverPass] = useState(false);
  let { refresh, access } = useParams();
  const [formRecoverPass, setFormRecoverPass] = useState({
    newPass: "",
    repeatPass: "",
    refresh_token: refresh,
    access: access,
  });

  const handleRecoverPass = async () => {
    setDisableBtnRecoverPass(true);
    setErrorRecoverPass("");
    setSuccessRecoverPass(false);
    const { newPass, repeatPass } = formRecoverPass;
    if (newPass !== "" && repeatPass !== "") {
      if (newPass === repeatPass) {
        localStorage.setItem("access", access);
        localStorage.setItem("refresh", refresh);
        const rs = await changeRecoverPassword(formRecoverPass);
        if (rs.status === 200) {
          setFormRecoverPass({
            newPass: "",
            repeatPass: "",
            refresh_token: "",
            access: "",
          });
          setSuccessRecoverPass(true);
        } else if (rs.status === 400) {
          setErrorRecoverPass(rs.data.msg);
        } else {
          setErrorRecoverPass(t('linkHasExpired', { ns: 'recover' }));
        }
      } else {
        setErrorRecoverPass(t('nocoincidepassword', { ns: 'backoffice' }));
        setDisableBtnRecoverPass(false);
      }

      unSetLocal("access");
      unSetLocal("refresh");
      setDisableBtnRecoverPass(false);
    } else {
      setErrorRecoverPass(t('allFieldsRequired', { ns: 'backoffice' }));
      setDisableBtnRecoverPass(false);
    }
  };

  useEffect(() => {
    window.document.title = `${t('resetPassword', { ns: 'backoffice' })} | ` + name;
  }, []);

  return (
    <div className="container p-rel">
      <div className="containerRecover margin-top-md">
        <h3>{t('cambiarcontrasena', { ns: 'backoffice' })}</h3>
        <div cclassName="custom-line">
          <hr />
        </div>
        {!successRecoverPass && (
          <div className="containerChangePass margin-top-md">
            <InputCustom
              type="password"
              value={formRecoverPass.newPass}
              label={t('newPassword', { ns: 'recover' })}
              placeholder={t('nuevacontrasena', { ns: 'backoffice' })}
              onChange={(e) =>
                setFormRecoverPass({
                  ...formRecoverPass,
                  newPass: e.target.value,
                })
              }
            />
            <InputCustom
              type="password"
              value={formRecoverPass.repeatPass}
              label={t('repeatpassword', { ns: 'backoffice' })}
              placeholder={t('repeatpassword', { ns: 'backoffice' })}
              onChange={(e) =>
                setFormRecoverPass({
                  ...formRecoverPass,
                  repeatPass: e.target.value,
                })
              }
            />
          </div>
        )}
        {errorRecoverPass !== "" && (
          <Row className="alert-danger">
            <span>{errorRecoverPass}</span>
          </Row>
        )}
        {successRecoverPass && (
          <Row className="alert-success">
            <span>{t('updatePassword', { ns: 'recover' })}</span>
          </Row>
        )}

        {!successRecoverPass && (
          <div className="containerButton">
            <Button
              variant="primary"
              disabled={disableBtnRecoverPass}
              onClick={disableBtnRecoverPass ? null : handleRecoverPass}
            >
              {disableBtnRecoverPass ? (
                <span>`{`${t('cargando', { ns: 'backoffice' })}...`}</span>
              ) : (
                <span>{t('cambiarcontrasena', { ns: 'backoffice' })}</span>
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Recover;
